<template>
<div class="bidResult">
  <div class="projectName">{{ project.name }}</div>
  <el-tabs type="border-card" @tab-click="tabClick" v-model="active">
    <el-tab-pane v-for="(item, index) in titleList" :key="index" :label="item.title" :name="item.name">
      <div v-if="item.name === '1'">
        <div v-if="list.length === 0 " class="noContent">
          <img src="../../assets/img/public/blank_icon_none.png">
        </div>
        <div v-else>
          <div class="basic evaluate-content" v-for="(item, index) in list" :key="index" @click="detail(item.id)">
            <el-tag color="#F54344" v-if="item.isWin == 1" type="primary" class="tag">中标</el-tag>
            <el-tag color="#ccc" v-else type="primary" class="tag">未中标</el-tag>
            <div style="display: flex">
              <div>
                <img class="headImg" src="../../assets/img/public/icon-default.png"
                     v-if="!item.headImg">
                <img :src="item.headImg" v-else class="headImg">
              </div>
              <div>
                <div class="evaluate-title">{{item.name}}</div>
                <div class="timeBox">
                  <div class="time">
                    <span class="timeTitle">投标金额</span>
                    <span>{{ item.bidPrice | currency }}元</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom" v-if="isNotice == 1">
            <el-button class="btnHeight_40 btWith_120" type="primary" @click="entertip">查看公告</el-button>
          </div>
        </div>
      </div>
      <div v-else>
        <!--项目详情-->
        <div class="project-info">
          <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
          <projectInfo :project="project"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="0"/>
          <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
          <projectInfo :project="project.oldInfo"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="1"/>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>

  <announcement v-if="entertipDialog" :projectId="id" @close="entertipDialog = false"/>
</div>
</template>

<script>
import { getTenderResult, getIsNotice, getNormalProjectInfo } from '@api/project'
import projectInfo from '@views/components/projectInfo'
import announcement from '@views/components/announcement'
export default {
  name: 'bidResult',
  components: { projectInfo, announcement },
  data () {
    return {
      project: {},
      id: '',
      titleList: [
        { name: '1', title: '投标人' },
        { name: '2', title: '项目详情' }
      ],
      active: '1',
      list: [],
      isNotice: '', // 是否发布公告：0-未发布；1-已发布
      entertipDialog: false,
    }
  },
  created () {
    this.id = this.$route.query.projectId
    this.getIsNotice()
    this.getNormalProjectInfo()
    // 获取中标队伍
    this.getTenderResult()
  },
  methods: {
    tabClick () {
      if (this.active === '1') {
        this.getTenderResult()
      } else if (this.active === '2') {
        this.getNormalProjectInfo()
      }
    },
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    getTenderResult () {
      getTenderResult({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    // 是否发布公告：0-未发布；1-已发布
    getIsNotice () {
      getIsNotice({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          // 是否发布公告：0-未发布；1-已发布
          this.isNotice = res.data.data.isNotice
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    entertip () {
      this.entertipDialog = true
    },
  }
}
</script>

<style scoped lang="scss">
.bidResult{
  width: 75%;
  .basic{
    /*display: flex;*/
    padding: 24px 0;
    .headImg{
      width: 66px;
      height: 66px;
      border-radius: 5px;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .evaluate-title{
      font-size: 20px;
      color: #333333;
      margin-bottom: 16px;
    }
    .time{
      font-size: 18px;
      color: #333333;
      .timeTitle{
        color: #999999;
        margin-right: 8px;
      }
    }
  }
  .bottom{
    width: 140px;
    margin: 40px auto;
  }
  .FinishText{
    font-size: 20px;
    color: #333333;
  }
}
</style>
